import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ColorZoomg = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 40 30"
      {...rest}
    >
      <path
        fill="#7D7D87"
        d="M4.479 0L18.598 0 22 5.337 10.887 22.809 15.536 30 8.619 30 4.026 22.809 14.062 7.135 0 7.135z"
        transform="translate(-524.000000, -1698.000000) translate(524.000000, 1698.000000)"
      />
      <path
        fill="#F43B67"
        d="M25.444 0L30.07 7.247 20.196 22.809 30.804 22.809 27.531 17.64 36.671 17.64 40 22.809 35.374 30 15.626 30 11 22.809z"
        transform="translate(-524.000000, -1698.000000) translate(524.000000, 1698.000000)"
      />
    </svg>
  );
};

ColorZoomg.displayName = 'ColorZoomg';
